// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import React from "react";
import { SvgIcon } from "@material-ui/core";
const ClustersIcon = () => {
  return (
    <SvgIcon>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 9">
        <g transform="translate(79 438.479)">
          <g>
            <g>
              <rect x="-77.9" y="-434.5" width="7.8" height="1" />
            </g>
          </g>
          <g>
            <g>
              <rect
                x="-77.9"
                y="-434.5"
                transform="matrix(0.4999 -0.8661 0.8661 0.4999 338.8698 -281.1237)"
                width="7.8"
                height="1"
              />
            </g>
          </g>
          <g>
            <g>
              <rect
                x="-74.5"
                y="-437.9"
                transform="matrix(0.866 -0.5001 0.5001 0.866 207.1129 -95.1668)"
                width="1"
                height="7.8"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-71.8-430.1h-4.5l-2.2-3.9l2.2-3.9h4.5l2.2,3.9L-71.8-430.1z M-75.7-431.1h3.3l1.7-2.9l-1.7-2.9h-3.3
				l-1.7,2.9L-75.7-431.1z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-72.3-434c0,0.9-0.7,1.7-1.7,1.7c-0.9,0-1.7-0.7-1.7-1.7c0-0.9,0.7-1.7,1.7-1.7
				C-73.1-435.7-72.3-434.9-72.3-434z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-76.8-434c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0c0-0.6,0.5-1.1,1.1-1.1
				c0,0,0,0,0,0C-77.3-435.1-76.8-434.6-76.8-434C-76.8-434-76.8-434-76.8-434z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-69-434c0,0.6-0.5,1.1-1.1,1.1c0,0,0,0,0,0c-0.6,0-1.1-0.5-1.1-1.1c0,0,0,0,0,0c0-0.6,0.5-1.1,1.1-1.1
				c0,0,0,0,0,0C-69.5-435.1-69-434.6-69-434C-69-434-69-434-69-434z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-75.4-431.6c0.5,0.3,0.7,1,0.4,1.5c-0.3,0.5-1,0.7-1.5,0.4c0,0,0,0,0,0c-0.5-0.3-0.7-1-0.4-1.5
				C-76.6-431.7-75.9-431.9-75.4-431.6C-75.4-431.6-75.4-431.6-75.4-431.6z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-71.5-438.3c0.5,0.3,0.7,1,0.4,1.5c-0.3,0.5-1,0.7-1.5,0.4c0,0,0,0,0,0c-0.5-0.3-0.7-1-0.4-1.5
				C-72.7-438.5-72-438.6-71.5-438.3C-71.5-438.3-71.5-438.3-71.5-438.3z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-72.6-431.6c0.5-0.3,1.2-0.1,1.5,0.4c0,0,0,0,0,0c0.3,0.5,0.1,1.2-0.4,1.5c-0.5,0.3-1.2,0.1-1.5-0.4
				c0,0,0,0,0,0C-73.3-430.6-73.1-431.3-72.6-431.6z"
              />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M-76.5-438.3c0.5-0.3,1.2-0.1,1.5,0.4c0,0,0,0,0,0c0.3,0.5,0.1,1.2-0.4,1.5c-0.5,0.3-1.2,0.1-1.5-0.4
				c0,0,0,0,0,0C-77.2-437.3-77-438-76.5-438.3z"
              />
            </g>
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default ClustersIcon;
